import { render, staticRenderFns } from "./SectionActiveTickets.vue?vue&type=template&id=1e4e301b&scoped=true&"
import script from "./SectionActiveTickets.vue?vue&type=script&lang=js&"
export * from "./SectionActiveTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionActiveTickets.vue?vue&type=style&index=0&id=1e4e301b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e301b",
  null
  
)

export default component.exports